import { ServiceOrder } from '@mews-commander/data-access';
import { OrderItem } from '@mews-commander/types';
import { Stack, Virtualizer } from '@optimus-web/core';
import { ServiceOrderItem } from '../ServiceOrderItem';
import { UngroupedServiceOrderItem } from './UngroupedOrderItem';

interface ServiceListProps {
    serviceOrders: ServiceOrder[];
    ungroupedOrderItems: OrderItem[];
    billId: string;
    accountId: string;
    depth?: number;
    isRebateScreen?: boolean;
}

export const ServiceList = ({
    serviceOrders,
    ungroupedOrderItems,
    billId,
    accountId,
    depth = 0,
    isRebateScreen = false,
}: ServiceListProps) => {
    const renderServiceOrderItem = (serviceOrder: ServiceOrder) => (
        <ServiceOrderItem
            key={serviceOrder.id}
            value={serviceOrder.id}
            serviceOrderId={serviceOrder.id}
            billId={billId}
            accountId={accountId}
            serviceId={serviceOrder.serviceId}
            depth={depth}
            month=""
            isRebateScreen={isRebateScreen}
        />
    );

    const renderUngroupedOrderItem = (orderItem: OrderItem) => (
        <UngroupedServiceOrderItem key={orderItem.id} orderItem={orderItem} />
    );

    const serviceOrdersList =
        serviceOrders.length < 15 ? (
            <div>{serviceOrders.map(renderServiceOrderItem)}</div>
        ) : (
            <div>
                <Virtualizer
                    height={600}
                    estimatedSize={40}
                    overscan={20}
                    items={serviceOrders.map(renderServiceOrderItem)}
                />
            </div>
        );

    return (
        <Stack vertical>
            {serviceOrdersList}
            <Stack vertical>{ungroupedOrderItems.map(renderUngroupedOrderItem)}</Stack>
        </Stack>
    );
};
